export const config = {
  mobileWaxWidth: 700,
  mobileNavigatorWidth: 900,
};
